import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate } from "@/lib/dates";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { HandCoins } from "lucide-react";

const money = (n) => `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

export const MyGiving = () => {
  const [giving, setGiving] = useState({ donations: [], total: 0 });
  useEffect(() => {
    api.get("/me/donations").then((r) => setGiving(r.data || { donations: [], total: 0 })).catch(() => {});
  }, []);

  return (
    <Card className="bg-white border border-[#E5E0D8] shadow-sm overflow-hidden" data-testid="portal-giving">
      <div className="flex items-center gap-2 p-5 border-b border-[#E5E0D8]">
        <HandCoins className="h-5 w-5 text-[#D97706]" />
        <h2 className="font-serif text-xl font-semibold">My Giving</h2>
        <span className="ml-auto font-serif text-lg font-bold text-[#D97706]" data-testid="portal-giving-total">{money(giving.total)}</span>
      </div>
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent border-[#E5E0D8]"><TableHead>Date</TableHead><TableHead>Category</TableHead><TableHead className="text-right">Amount</TableHead></TableRow>
        </TableHeader>
        <TableBody>
          {giving.donations.map((d) => (
            <TableRow key={d.id} className="border-[#E5E0D8]" data-testid={`portal-donation-${d.id}`}>
              <TableCell className="text-sm text-[#526050]">{fmtDate(d.date)}</TableCell>
              <TableCell className="text-[#1C241B]">{d.category}</TableCell>
              <TableCell className="text-right font-semibold text-[#1C241B]">{money(d.amount)}</TableCell>
            </TableRow>
          ))}
          {giving.donations.length === 0 && <TableRow><TableCell colSpan={3} className="text-center py-10 text-[#7A8A78]">No giving records yet.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </Card>
  );
};
